import React from 'react'
import ContentLoader from 'react-content-loader'

const ReviewsSkeleton = () => (
  <ContentLoader
    data-test='reviews-skeleton'
    speed={2}
    width={730}
    height={200}
    viewBox='0 0 730 200'
    primaryColor='#f3f3f3'
    secondaryColor='#ecebeb'
  >
    <rect x='0' y='6' rx='0' ry='0' width='200' height='25' />
    <rect x='0' y='40' rx='0' ry='0' width='300' height='20' />
    <rect x='1' y='70' rx='0' ry='0' width='700' height='70' />
    <rect x='-2' y='150' rx='0' ry='0' width='100' height='30' />
    <rect x='120' y='150' rx='0' ry='0' width='100' height='30' />
  </ContentLoader>
)

export default ReviewsSkeleton
